import { jsx as t, jsxs as s } from "react/jsx-runtime";
import "react";
import { classes as l } from "../../../utils/helpers.js";
import { StringList as e } from "../../StringList/StringList.js";
import { AirDateSegment as f } from "./AirDateSegment.js";
import { ImageCard as g } from "../../ImageCard/ImageCard.js";
import { Concat as C } from "../../Concat/Concat.js";
function j({ scheduleItem: i, styles: r, strListArr: a, handleClicks: n, determineCTA: p }) {
  var o;
  const m = [
    `<div>${i.title_name}</div>`,
    /* @__PURE__ */ t(e, { list: a, separatorType: "pipe" })
  ];
  return /* @__PURE__ */ s("li", { className: l([r["schedule-list__item"], "schedule-list__item"]), children: [
    /* @__PURE__ */ t(f, { scheduleItem: i, styles: r }),
    /* @__PURE__ */ t(
      g,
      {
        id: i.id,
        image: {
          url: ((o = i == null ? void 0 : i.content) == null ? void 0 : o.image) ?? "",
          altText: "",
          aspectRatio: 543 / 305
        },
        title: i.program,
        content: /* @__PURE__ */ t(C, { list: m }),
        cta: p(i),
        clampContentLines: !0,
        numberOfLinesToClamp: 5,
        displayInline: !0,
        handleClicks: n
      }
    )
  ] }, `schedule-list-${i.id}`);
}
export {
  j as SportsItem,
  j as default
};
